import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

// Filled speech bubble with a tail, mirroring the Zendesk web widget launcher glyph.
export default withIconWrapper(function ChatBubble({ size, color, ...props }) {
  return (
    <Svg height={size} viewBox="0 0 24 24" width={size} {...props}>
      <Path
        d="M6 4h12a3 3 0 013 3v6a3 3 0 01-3 3h-6l-4 4v-4H6a3 3 0 01-3-3V7a3 3 0 013-3z"
        fill={color}
      />
    </Svg>
  );
});
